import React, { useLayoutEffect, useRef } from "react";

// NOTE: despite the name, this now only drives "scroll to bottom on the next
// render" (the Android keyboard-focus path sets `shouldScrollToBottom`). The
// old keep-scroll-position branch wrote `scrollTo` directly on Virtuoso's own
// scroller and fought its anchoring; it was removed when infinite scroll-up
// moved to Virtuoso's `firstItemIndex` protocol — see MESSAGES_SCROLL_FLOW.md.
export default function useKeepScrollPosition(ref: React.MutableRefObject<HTMLElement | null>) {
  const shouldScrollToBottom = useRef(false);

  const scrollToBottom = () => {
    setTimeout(() => {
      if (!ref.current?.scrollTo) return;
      ref.current.scrollTo(0, ref.current.scrollHeight - ref.current.offsetHeight);
    });
  };
  useLayoutEffect(() => {
    if (shouldScrollToBottom.current) {
      scrollToBottom();
    }
  });
  useLayoutEffect(() => {
    shouldScrollToBottom.current = false;
  });
  return {
    shouldScrollToBottom,
  };
}
